import React from 'react';
import { Layout, Menu } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router';
import { observer } from 'mobx-react';
import { Bind } from 'lodash-decorators';
import { A } from '../../../../shared/libs/a-component/route/menus/sync/A';
import { RouteSetting } from '../../../../shared/libs/a-component/route/RouteSetting';
import {
    menuCollapsedStore,
    sideState,
    sideStateMap,
    STORE_SIDE_STATE_NAME,
} from '../../../../shared/libs/a-component/route/menus/menuStatusStore';
import {
    KDevSiderFooter,
    IKDevSiderFooterProps,
} from './PageLayoutSiderFooter';
import css from './PageLayoutSider.less';
import { TrackReport } from '../../../../shared/common/trackReport';

const { Sider } = Layout;

export function getSiderMenuCurrentName() {
    const hits = document.getElementsByClassName('ant-menu-item-selected');
    // $('.ant-menu-item-selected').dataset.uiTestInfo
    const hit = hits[0] as HTMLElement | undefined;
    if (hit?.dataset?.trackTitle) {
        return hit.dataset.trackTitle;
    }

    return '';
}

export interface IKDevPageSiderProps {
    routeSetting: RouteSetting;
    menuHeader?: (collapse: boolean) => React.ReactNode;
    onMenuClick?: (menuName: string | undefined) => void;

    footerText?: string;
    onFooterTextClick?: () => void | null;
    additional?: (collapse: boolean) => React.ReactNode;
}

export function setSiderCollapsed(state: boolean) {
    menuCollapsedStore.changeCollapsed(state);
}

/**
 * 获取展开的菜单
 */
let openKeys: string[] = [];
export function setOpenKeys(keys: string[]) {
    openKeys = keys;
}
function getOpenKeys(): string[] {
    return openKeys;
}

@observer
class PageSider extends React.Component<
    IKDevPageSiderProps & RouteComponentProps & IKDevSiderFooterProps
> {
    state = {
        openKeys: getCollapseState() ? [] : getOpenKeys(),
    };

    constructor(props) {
        super(props);
        menuCollapsedStore.setDefaultValue(getCollapseState());
    }

    // this.state.openKeys 受控
    public changeOpenKey = (keys) => {
        this.setState({
            openKeys: keys,
        });
        if (keys.length > 0) {
            setOpenKeys(keys); // 借助openKeys存储用户展开的菜单
        }
    };

    // 该方法会调用changeOpenKey修改openKeys，收起时调用this.changeOpenKey([])，
    // 导致用户展开的菜单，在折叠又打开sider后，全部收起
    public toggleIcon = () => {
        const state = !menuCollapsedStore.collapsed;
        if (state) {
            setOpenKeys(this.state.openKeys); // 借助openKeys存储用户展开的菜单
        }
        if (menuCollapsedStore.collapsed) {
            this.setState({
                openKeys: getOpenKeys(), // 展开后给this.state.openKeys重新赋值
            });
        }
        menuCollapsedStore.changeCollapsed(state);
    };

    renderMenuContent() {

        return (
            <Menu
                className={css.kDevSliderMenu}
                mode="inline"
                selectedKeys={[
                    getMenuSelectedKeys(
                        this.props.location.pathname,
                        this.props.routeSetting
                    ),
                ]}
                openKeys={this.state.openKeys}
                onOpenChange={this.changeOpenKey}
                inlineIndent={16}
            >
                {renderRouteSetting(
                    this.props.routeSetting,
                    this.props.onMenuClick
                )}
                {this.props.additional?.(menuCollapsedStore.collapsed)}
            </Menu>
        );
    }

    renderMenuHeader() {
        try {
            const ele = this.props.menuHeader?.(menuCollapsedStore.collapsed);
            if (ele) {
                return <div className={css.menuHeaderBox}>{ele}</div>;
            }
        } catch (err) {
            console.error(err);
        }
        return <div></div>;
    }

    renderMenuFooter() {
        return (
            <KDevSiderFooter
                onToggle={this.toggleIcon}
                footerText={this.props.footerText}
                onFooterTextClick={this.props.onFooterTextClick}
            />
        );
    }

    render() {
        if (RouteSetting.isFullScreen() || !this.props.routeSetting) {
            return null;
        }

        return (
            <Sider
                className={css.siderBox}
                width={'220px'}
                collapsed={menuCollapsedStore.collapsed}
            >
                <TrackReport trackInfo="侧边导航顶部">
                    {this.renderMenuHeader()}
                </TrackReport>
                <TrackReport trackInfo="侧边导航">
                    {this.renderMenuContent()}
                </TrackReport>
                <TrackReport trackInfo="侧边导航底部">
                    {this.renderMenuFooter()}
                </TrackReport>
            </Sider>
        );
    }
}

// 设置左侧默认折起方法
let set_default_collapsed_handlers: (() => boolean | undefined) | null = null;
export function setDefaultCollapsed(handler: () => boolean | undefined) {
    set_default_collapsed_handlers = handler;
}

function restoreCollapseState() {
    const val = localStorage.getItem(STORE_SIDE_STATE_NAME);
    return val ? sideStateMap[val] : sideStateMap[sideState.open];
}

function getCollapseState() {
    if (set_default_collapsed_handlers) {
        const collapeds = set_default_collapsed_handlers();
        if (collapeds !== undefined) {
            return collapeds;
        }
    }
    return restoreCollapseState();
}

function renderRouteSetting(
    router: RouteSetting,
    onMenuClick?: (menuName?: string) => void
): React.ReactNode {
    if (router.forbiddenMenu) {
        return null;
    }

    const hanldeClickMenu = (e, router: RouteSetting) => {
        try {
            if (
                router.onMenuItemClick &&
                router.onMenuItemClick(router) === false
            ) {
                e.preventDefault();
                return;
            }
        } catch (err) {
            console.error(err);
        }

        onMenuClick?.(router?.title);
    };

    const title = (
        <span className={css.icon}>
            {router.iconType /* 此处不要包裹标签，会导致 菜单 收缩显示错误 */}
            <span className={`${css.menuTitle} kdev-page-slider-submenu-item`}>
                {router.title}
            </span>
        </span>
    );

    if (!router.routeSettings) {
        if (router.type === 'group-divide') {
            if (!menuCollapsedStore.collapsed) {
                const arr = [<Menu.Divider />];
                if (router.title) {
                    arr.push(<Menu.ItemGroup title={router.title} />);
                }
                return arr;
            }
            return null;
        }

        if (router.type === 'group') {
            if (!menuCollapsedStore.collapsed) {
                const arr: any[] = [];
                if (router.title) {
                    arr.push(<Menu.ItemGroup title={router.title} className={css.menuGroup} />);
                }
                return arr;
            }
            return null;
        }

        return (
            <Menu.Item
                key={router.getMenuKey()}
                data-ui-test-info={`menu-(${router.dataUITestInfo || router.title
                    })`}
                data-track-title={`${router.title}`}
            >
                <A
                    path={router.path}
                    dynamicPath={router.dynamicPath?.(router)}
                    style={{ color: 'unset', transition: 'unset' }}
                    params={router.getQsFields()}
                    onClick={(e) => hanldeClickMenu(e, router)}
                >
                    {title}
                </A>
            </Menu.Item>
        );
    }
    if (router.isRoot) {
        return router.routeSettings.map((it) =>
            renderRouteSetting(it, onMenuClick)
        );
    }

    return (
        <Menu.SubMenu title={title} key={router.getMenuKey()}>
            {menuCollapsedStore.collapsed ? (
                <li className={css.subMenuTitleName}>{title}</li>
            ) : null}
            {router.routeSettings.map((it) =>
                renderRouteSetting(it, onMenuClick)
            )}
        </Menu.SubMenu>
    );
}

export function getMenuSelectedKeys(pathname, router: RouteSetting) {
    const routeObj = getRouteObj(pathname, router);
    return routeObj?.selectMenuKey || routeObj?.menuKey || pathname;
}

export function getRouteObj(pathname, router: RouteSetting) {
    if (!router.routeSettings) {
        return;
    }
    let routeObj = router.routeSettings.find(
        (item) => item.path === pathname || pathname.includes(item.menuKey)
    );

    if (!routeObj) {
        router.routeSettings.some((item) => {
            routeObj = getRouteObj(pathname, item);
            return !!routeObj;
        });
    }
    return routeObj;
}


export const KDevPageSider = withRouter(PageSider);
